export default __webpack_public_path__ + "static/media/mg.b1c9e462.svg";